import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    copiedLabel: { type: String, default: "Copied" },
  };

  async copy() {
    await navigator.clipboard.writeText(this.urlValue);
    this.element.textContent = this.copiedLabelValue;
  }
}
